import createAbsolutePath from "createAbsolutePath";
import NavBarItemDropdownMenu from "Header/NavBarItemDropdownMenu";

export const browseCatalog = {
  label: "Browse Catalog",
  route: createAbsolutePath("/products"),
};
export const passport = {
  label: "Passport",
  route: "/r/passport",
};

const NavBarShopDropdown = () => {
  return (
    <NavBarItemDropdownMenu
      value="Discover + Shop"
      options={[browseCatalog, passport]}
    />
  );
};

export default NavBarShopDropdown;
